import { addReportTable } from "reporting/pdf/addReportTable";
import { addKeyValueBlock } from "reporting/pdf/pdfLayout";
import { fmtNumber, fmtPctDecimal } from "reporting/pdf/pdfFormatters";
import { PDF_STONE } from "reporting/pdf/pdfTheme";

const PERIOD_COLUMNS = [
  { key: "fundName", label: "Fund", align: "left" },
  { key: "beginningMarketValue", label: "Beg Market Value", align: "right" },
  { key: "endingMarketValue", label: "End Market Value", align: "right" },
  { key: "changeInMarketValue", label: "Change in MV", align: "right" },
  { key: "beginningBookValue", label: "Beg Book Value", align: "right" },
  { key: "endingBookValue", label: "End Book Value", align: "right" },
  { key: "changeInBookValue", label: "Change in BV", align: "right" },
  { key: "fullyAccruedInterest", label: "Accrued Interest", align: "right" },
  { key: "yield", label: "Yield", align: "right" },
];

const PERIOD_COLUMN_WIDTHS = [86, 86, 86, 86, 86, 86, 86, 86, 28];

const DATE_COLUMNS = [
  { key: "fundName", label: "Fund", align: "left" },
  { key: "endingBookValue", label: "Book Value", align: "right" },
  { key: "endingMarketValue", label: "Market Value", align: "right" },
  { key: "fullyAccruedInterest", label: "Accrued Interest", align: "right" },
];

const DATE_COLUMN_WIDTHS = [172, 120, 120, 120];

function formatCurrency(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return "—";
  const formatted = `$${fmtNumber(Math.abs(number), 2)}`;
  return number < 0 ? `(${formatted})` : formatted;
}

function formatRow(row) {
  return {
    ...row,
    beginningBookValue: formatCurrency(row.beginningBookValue),
    changeInBookValue: formatCurrency(row.changeInBookValue),
    endingBookValue: formatCurrency(row.endingBookValue),
    beginningMarketValue: formatCurrency(row.beginningMarketValue),
    changeInMarketValue: formatCurrency(row.changeInMarketValue),
    endingMarketValue: formatCurrency(row.endingMarketValue),
    fullyAccruedInterest: formatCurrency(row.fullyAccruedInterest),
    yield: row.yield == null ? "—" : fmtPctDecimal(row.yield, 3),
  };
}

function styleTotalRow(totalIndex) {
  return (hookData) => {
    if (hookData.section !== "body" || hookData.row.index !== totalIndex) return;
    hookData.cell.styles.fontStyle = "bold";
    hookData.cell.styles.fillColor = PDF_STONE.surface;
    hookData.cell.styles.lineColor = PDF_STONE.secondaryLight;
    hookData.cell.styles.lineWidth = { top: 0.8, right: 0.25, bottom: 0.25, left: 0.25 };
  };
}

export function renderFundOverviewPdf(ctx, data, portfolioName = "") {
  const { margins } = ctx;
  const isPeriodReport = data?.reportMode === "period";
  const columns = isPeriodReport ? PERIOD_COLUMNS : DATE_COLUMNS;
  const columnWidths = isPeriodReport ? PERIOD_COLUMN_WIDTHS : DATE_COLUMN_WIDTHS;
  let y = margins.top + 2;

  y = addKeyValueBlock(
    ctx,
    [{ label: "Portfolio", value: portfolioName || "Current Portfolio" }],
    y,
    { columns: 1, labelWidth: 58, rowHeight: 14, spaceAfter: 2 }
  );

  const rows = [...(data?.rows || []), data?.totals].filter(Boolean).map(formatRow);
  addReportTable(
    ctx,
    {
      title: "Fund Overview",
      columns,
      rows,
      fontSize: 6.2,
      columnStyles: Object.fromEntries(
        columnWidths.map((cellWidth, index) => [index, { cellWidth }])
      ),
      styles: { cellPadding: 2, minCellHeight: 11 },
      headStyles: {
        fillColor: PDF_STONE.primary,
        textColor: PDF_STONE.white,
        fontSize: 6.2,
        cellPadding: 2,
      },
      titleOptions: { spaceBefore: 8, spaceAfter: 8 },
      rowPageBreak: "avoid",
      showHead: "everyPage",
      didParseCell: styleTotalRow(rows.length - 1),
    },
    y
  );
}

export default renderFundOverviewPdf;
